import { Link } from 'react-router-dom';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarDays, faArrowUpRightFromSquare, faArrowRight } from '@fortawesome/free-solid-svg-icons';

import portfolio from '../../../data';
import { careerYearsFormatted } from '../../../utils/yearsOfExperience';
import Reveal from '../../ui/Reveal';
import SpotlightCard from '../../ui/SpotlightCard';

import '../../../styles/About/Route/Experience.scss';

const Experience = () => {
  const jobs = portfolio.portfolio.experience;

  return (
    <div className="experience container">
      <header className="experience__header">
        <Reveal as="p" className="experience__eyebrow" variant="blur">
          02 — Experience
        </Reveal>
        <Reveal as="h1" className="experience__title" delay={100}>
          <span className="gradient-text">{careerYearsFormatted()}+ years</span> of building.
        </Reveal>
      </header>

      <ol className="experience__list">
        {jobs.map((job, i) => (
          <li key={`${job.company}-${job.period}`} className="experience__item">
            <span className={`experience__dot${/present/i.test(job.period) ? ' experience__dot--current' : ''}`} aria-hidden="true" />
            <Reveal>
              <SpotlightCard className="experience__card">
                <p className="experience__period">
                  <FontAwesomeIcon icon={faCalendarDays} aria-hidden="true" /> {job.period}
                </p>
                <h2>{job.role}</h2>
                <p className="experience__company">
                  {job.companyUrl ? (
                    <a href={job.companyUrl} target="_blank" rel="noopener noreferrer">
                      {job.company} <FontAwesomeIcon icon={faArrowUpRightFromSquare} aria-hidden="true" />
                    </a>
                  ) : (
                    job.company
                  )}
                  <span> · {job.location}</span>
                  {job.note && <span className="experience__note"> · {job.note}</span>}
                </p>

                <ul className="experience__stack" aria-label="Tech stack">
                  {job.stack.map((s) => (
                    <li key={s} className="chip">
                      {s}
                    </li>
                  ))}
                </ul>

                {job.projects.map((project) => (
                  <div className="experience__project" key={project.name}>
                    <h3>{project.name}</h3>
                    <p className="experience__summary">{project.summary}</p>
                    <ul className="experience__points">
                      {project.points.map((point) => (
                        <li key={point}>{point}</li>
                      ))}
                    </ul>
                  </div>
                ))}
              </SpotlightCard>
            </Reveal>
          </li>
        ))}
      </ol>

      <Reveal className="experience__cta">
        <Link to="/#work" className="btn btn--primary">
          Explore my projects <FontAwesomeIcon icon={faArrowRight} aria-hidden="true" />
        </Link>
      </Reveal>
    </div>
  );
};

export default Experience;
